// extracted by mini-css-extract-plugin
export var checkbox = "_6x-0";
export var circle = "_6x-3";
export var horizontalContainer = "_6x-7";
export var sm = "_6x-5";
export var switch0 = "_6x-2";
export var switchDisabled = "_6x-8";
export var switchEnabled = "_6x-1";
export var textSwitchContainer = "_6x-9";
export var textSwitchOption = "_6x-a";
export var textSwitchOptionSelected = "_6x-b";
export var verticalContainer = "_6x-6";
export var xs = "_6x-4";